(($, window, undefined) => {
    if (window.mg === undefined)
        window.mg = {};

    const _ = window.mg;

    const _iframe = {};

    class ProfileImg {
        constructor() {
        }

        modal() {
            return _.showModal('#modal-profile-img');
        }

        register(form) {
            _iframe.$form = $(form);
            _iframe.$file = $('input[type="file"]', form);

            const $btnBrowse = $('button[data-browser="1"]', '#modal-profile-img');

            _iframe.$file.on('change', () => {
                $btnBrowse.prop('disabled', true);

                this.updateImage(2, 'none');

                setTimeout(() => {
                    const fileName = _iframe.$file.val().toLowerCase();

                    if (_.endsWith(fileName, '.jpg') || _.endsWith(fileName, '.png')) {
                        _iframe.$form.submit();
                    } else {
                        this.uploadError('filetypeerror');
                    }
                }, 1000);
            });
        }

        browse() {
            _iframe.$file &&
            _iframe.$file.focus() &&
            _iframe.$file.click();
        }

        delete(confirmed) {
            if (!confirmed) {
                _.ui.confirmmodal({
                    html          : _.translations.AreYouSureYouWantToRemoveYourProfilePicture,
                    btnYesOnClick : () => {
                        this.delete(true);
                    }
                });

                return;
            }

            _.ajax.post('/Site/Settings/ContactDetails/IframeProfileInfo?handler=Delete').done(() => {
                this.updateImage(0, 'none');
            });
        }

        uploadError(message) {
            const $modal     = $('#modal-profile-img');
            const $btnBrowse = $('button[data-browser="1"]', $modal);
            const $iframe    = $('iframe', $modal);

            const html = `<div class="alert alert-danger alert-dismissible fade show" role="alert">` +
                message +
                `<button type="button" class="close" data-dismiss="alert" aria-label="Close">` +
                    `<span aria-hidden="true">&times;</span>` +
                `</button>` +
            `</div>`;

            $btnBrowse.before(html);
            $btnBrowse.prop('disabled', false);
            $iframe.attr('src', $iframe.attr('src'));

            this.updateImage(0, 'none');
        }

        uploadSuccess(message) {
            const $modal      = $('#modal-profile-img');
            const $btnBrowse  = $('button[data-browser="1"]', $modal);
            const $iframe     = $('iframe', $modal);

            $btnBrowse.prop('disabled', false);
            $iframe.attr('src', $iframe.attr('src'));

            this.updateImage(1, 'url(' + message + ')');
        }

        updateImage(state, image) {
            const $rowExists = $('.row[data-state]', '#modal-profile-img');
            const $imgExists = $('.profile-img-block[data-state]');
            const $img       = $('.profile-img');

            $rowExists.attr('data-state', state);
            $imgExists.attr('data-state', state);
            $img.css('background-image', image);
        }
    }

    _.profileImg = new ProfileImg();
})(jQuery, window);
